import React from 'react'
import Header from 'components/users/header'
import Main from 'components/users/main'
import Navbar from 'components/dashboard/navbar'
import Footer from 'components/dashboard/footer'

export default function user() {
    return (
        <>
           < Navbar/> 
           < Header/> 
           < Main/> 
           < Footer/> 
        </>
    )
}
